import { render, staticRenderFns } from "./BetslipFooter.vue?vue&type=template&id=5f8e627e&scoped=true"
import script from "./BetslipFooter.vue?vue&type=script&lang=js"
export * from "./BetslipFooter.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooter.vue?vue&type=style&index=0&id=5f8e627e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e627e",
  null
  
)

export default component.exports